import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import AkkhorLayout from "../layout/akkhor";
import Spinner from "../component/Spinner";
import SearchBoxModal from "../component/SearchBoxModal";
import { URL_LIST_ALL } from "../configs/api";

/**
 * CÀI ĐẶT CÔNG — SỐ CÔNG BỊ TRỪ THEO CHÍNH SÁCH
 *
 * Công ty giảm ngày công của mỗi cán bộ do tình hình kinh tế. Phần đã bù bằng nghỉ
 * thứ 7 nằm sẵn trong công chuẩn; phần còn thiếu khấu trừ qua màn hình này và hiện
 * ở cột "Công thực nhận" trên bảng chấm công tháng + bảng chốt công:
 *
 *     Công thực nhận = Công hưởng lương − mức trừ
 *
 * Cột "Công hưởng lương" GIỮ NGUYÊN cách tính cũ, để người lao động đếm tay trên
 * bảng chấm công vẫn khớp, còn khoản giảm hiện rõ ở cột cuối.
 *
 * Dội từ trên xuống: ngoại lệ cá nhân → công ty → mặc định → 0.
 * Backend: App\Services\CaiDatCong.
 */
export default function CaiDatCong() {
    const { user } = useSelector((state) => state.auth);
    const [danhSach, setDanhSach] = useState([]);
    const [mucMacDinh, setMucMacDinh] = useState(0);
    const [giaTri, setGiaTri] = useState({});
    const [nhapMacDinh, setNhapMacDinh] = useState("");
    const [dangLuu, setDangLuu] = useState(null);
    const [dangTai, setDangTai] = useState(true);
    const [refresh, setRefresh] = useState(false);

    // Ngoại lệ cá nhân
    const [ngoaiLe, setNgoaiLe] = useState([]);
    const [userMoi, setUserMoi] = useState(null);
    const [mucMoi, setMucMoi] = useState("");
    const [ghiChuMoi, setGhiChuMoi] = useState("");
    const [resetKey, setResetKey] = useState(0);

    // Danh sách công ty + mức trừ + người sửa gần nhất (1 request, không N+1)
    useEffect(() => {
        let mounted = true;
        setDangTai(true);
        Axios.get(URL_LIST_ALL + "caidatcong_congty", user.config)
            .then((res) => {
                if (!mounted) return;
                if (res.data.status === "success") {
                    const ds = res.data.data || [];
                    setMucMacDinh(res.data.muc_mac_dinh || 0);
                    setNhapMacDinh(String(res.data.muc_mac_dinh || 0));
                    setDanhSach(ds);
                    const gt = {};
                    ds.forEach((c) => {
                        gt[c.id] = c.socongtru === null || c.socongtru === undefined ? "" : String(c.socongtru);
                    });
                    setGiaTri(gt);
                }
                setDangTai(false);
            })
            .catch((err) => {
                console.log(err);
                if (mounted) setDangTai(false);
            });
        return () => (mounted = false);
    }, [user, refresh]);

    useEffect(() => {
        let mounted = true;
        Axios.get(URL_LIST_ALL + "caidatcong_canhan_ds", user.config)
            .then((res) => {
                if (!mounted) return;
                if (res.data.status === "success") setNgoaiLe(res.data.data || []);
            })
            .catch((err) => console.log(err));
        return () => (mounted = false);
    }, [user, refresh]);

    const xemLichSu = (thamSo, tieuDe) => {
        Axios.get(URL_LIST_ALL + "caidatcong_lichsu?" + thamSo, user.config)
            .then((res) => {
                const ds = (res.data && res.data.data) || [];
                confirmAlert({
                    title: "Lịch sử đổi mức trừ công",
                    message: tieuDe,
                    childrenElement: () => (
                        <div style={{ maxHeight: 320, overflowY: "auto", marginTop: 10 }}>
                            {ds.length === 0 ? (
                                <p className="text-muted">Chưa có lần đổi nào được ghi nhận.</p>
                            ) : (
                                <table className="table table-sm" style={{ fontSize: 13 }}>
                                    <thead>
                                        <tr><th>Thời điểm</th><th>Người sửa</th><th>Thay đổi</th></tr>
                                    </thead>
                                    <tbody>
                                        {ds.map((h) => (
                                            <tr key={h.id}>
                                                <td className="text-nowrap">{h.thoi_diem}</td>
                                                <td>{h.nguoi_sua || "—"}{h.ma_nguoi_sua ? " (" + h.ma_nguoi_sua + ")" : ""}</td>
                                                <td className="text-nowrap">{h.tu} → <strong>{h.den}</strong></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    ),
                    buttons: [{ label: "Đóng" }],
                });
            })
            .catch((err) => console.log(err));
    };

    // Kiểm tra ô nhập: để trống là hợp lệ (= gỡ cài riêng), còn lại phải 0..31.
    const kiemTra = (raw) => {
        if (raw === "") return { ok: true, so: null };
        const so = parseFloat(raw);
        if (isNaN(so) || so < 0 || so > 31) return { ok: false, so: null };
        return { ok: true, so: so };
    };

    const goi = (thamSo, thongBao, khoa) => {
        setDangLuu(khoa);
        Axios.get(URL_LIST_ALL + "caidatcong_luu?" + thamSo, user.config)
            .then((res) => {
                setDangLuu(null);
                if (res.data.status === "success") {
                    setRefresh((r) => !r);
                    confirmAlert({ title: "Thành công", message: res.data.message || thongBao, buttons: [{ label: "OK" }] });
                } else {
                    confirmAlert({ title: "Lỗi", message: res.data.message || "Không lưu được", buttons: [{ label: "OK" }] });
                }
            })
            .catch((err) => {
                setDangLuu(null);
                console.log(err);
            });
    };

    const luuMacDinh = () => {
        const kt = kiemTra(nhapMacDinh.trim());
        if (!kt.ok) {
            confirmAlert({ title: "Giá trị không hợp lệ", message: "Số công trừ phải từ 0 đến 31.", buttons: [{ label: "OK" }] });
            return;
        }
        const so = kt.so === null ? 0 : kt.so;
        confirmAlert({
            title: "Xác nhận đổi mức mặc định",
            message: "Mọi công ty CHƯA cài riêng sẽ bị trừ " + so + " công mỗi kỳ. Thay đổi này ảnh hưởng tới cột Công thực nhận trên bảng chấm công và bảng chốt công.",
            buttons: [
                { label: "Đồng ý", onClick: () => goi("loai=macdinh&socongtru=" + so, "Đã lưu", "macdinh") },
                { label: "Huỷ" },
            ],
        });
    };

    const luuCongTy = (congty) => {
        const raw = (giaTri[congty.id] || "").trim();
        const kt = kiemTra(raw);
        if (!kt.ok) {
            confirmAlert({
                title: "Giá trị không hợp lệ",
                message: "Số công trừ phải từ 0 đến 31. Để trống nếu muốn dùng mức mặc định (" + mucMacDinh + ").",
                buttons: [{ label: "OK" }],
            });
            return;
        }
        const apDung = kt.so === null ? mucMacDinh : kt.so;
        confirmAlert({
            title: "Xác nhận đổi mức trừ công",
            message:
                "Nhân sự của " + congty.title + " sẽ bị trừ " + apDung + " công mỗi kỳ" +
                (kt.so === null ? " (theo mức mặc định)" : "") + ". " +
                (congty.so_ngoaile > 0 ? congty.so_ngoaile + " người có ngoại lệ riêng sẽ KHÔNG bị ảnh hưởng. " : "") +
                "Cột Công thực nhận trên bảng chấm công và bảng chốt công sẽ đổi theo.",
            buttons: [
                {
                    label: "Đồng ý",
                    onClick: () => goi(
                        "loai=congty&company_id=" + congty.id + (kt.so === null ? "&socongtru=" : "&socongtru=" + kt.so),
                        "Đã lưu", congty.id
                    ),
                },
                { label: "Huỷ" },
            ],
        });
    };

    const themNgoaiLe = () => {
        if (!userMoi) {
            confirmAlert({ title: "Thiếu thông tin", message: "Vui lòng chọn nhân sự.", buttons: [{ label: "OK" }] });
            return;
        }
        const kt = kiemTra(mucMoi.trim());
        if (!kt.ok || kt.so === null) {
            confirmAlert({ title: "Giá trị không hợp lệ", message: "Nhập số công trừ từ 0 đến 31 cho ngoại lệ này.", buttons: [{ label: "OK" }] });
            return;
        }
        goi(
            "loai=canhan&user_id=" + userMoi + "&socongtru=" + kt.so + "&ghichu=" + encodeURIComponent(ghiChuMoi),
            "Đã thêm ngoại lệ", "them"
        );
        setUserMoi(null);
        setMucMoi("");
        setGhiChuMoi("");
        setResetKey((k) => k + 1);
    };

    const xoaNgoaiLe = (row) => {
        confirmAlert({
            title: "Bỏ ngoại lệ",
            message: "Bỏ ngoại lệ của " + row.fullname + "? Người này sẽ quay về mức của công ty (" + row.muc_congty + " công).",
            buttons: [
                { label: "Đồng ý", onClick: () => goi("loai=canhan&user_id=" + row.user_id + "&socongtru=", "Đã bỏ ngoại lệ", "xoa" + row.id) },
                { label: "Huỷ" },
            ],
        });
    };

    return (
        <AkkhorLayout idrole="cai-dat-cong">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li>Cài đặt công</li>
                </ul>
            </div>

            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title"><h3>Số công bị trừ theo chính sách</h3></div>
                    </div>

                    <div className="alert alert-info" style={{ fontSize: 13 }}>
                        <strong>Cách hoạt động:</strong> cột <strong>Công thực nhận</strong> trên bảng
                        chấm công tháng và bảng chốt công = <strong>Công hưởng lương − mức trừ</strong>.
                        Cột Công hưởng lương giữ nguyên cách tính cũ, nên nhân sự đếm tay trên bảng
                        chấm công vẫn khớp; khoản giảm hiện riêng ở cột cuối.
                        <br />
                        Thứ tự ưu tiên: <strong>ngoại lệ cá nhân → công ty → mặc định</strong>.
                        Để trống ô của công ty thì dùng mức mặc định. Chưa cài gì thì trừ 0.
                    </div>

                    <div className="row align-items-end mb-4" style={{ borderBottom: "1px solid #eee", paddingBottom: 15 }}>
                        <div className="col-lg-3 col-md-6 col-12 form-group mb-0">
                            <label><strong>Mức trừ mặc định</strong> (áp cho công ty chưa cài riêng)</label>
                            <input type="number" min="0" max="31" step="0.5" className="form-control height32"
                                value={nhapMacDinh} onChange={(e) => setNhapMacDinh(e.target.value)} />
                        </div>
                        <div className="col-lg-3 col-12 form-group mb-0">
                            <button type="button" className="btn btn-sm btn-primary" disabled={dangLuu === "macdinh"} onClick={luuMacDinh}>
                                {dangLuu === "macdinh" ? <Spinner /> : "Lưu mức mặc định"}
                            </button>
                            <button type="button" className="btn btn-sm btn-outline-secondary ml-1" onClick={() => xemLichSu("", "Toàn bộ thay đổi")}>
                                Lịch sử
                            </button>
                        </div>
                    </div>

                    {dangTai ? (
                        <div className="text-center p-4"><Spinner /></div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table display data-table text-nowrap">
                                <thead>
                                    <tr>
                                        <th style={{ width: 60 }}>ID</th>
                                        <th>Công ty</th>
                                        <th style={{ width: 150 }}>Số công trừ</th>
                                        <th style={{ width: 200 }}>Đang áp dụng</th>
                                        <th style={{ width: 120 }}>Ngoại lệ</th>
                                        <th style={{ width: 230 }}>Cập nhật gần nhất</th>
                                        <th style={{ width: 150 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {danhSach.map((c) => {
                                        const raw = giaTri[c.id];
                                        const dungMacDinh = !raw || raw === "";
                                        const kt = kiemTra((raw || "").trim());
                                        const muc = dungMacDinh ? mucMacDinh : kt.so;
                                        return (
                                            <tr key={c.id}>
                                                <td>{c.id}</td>
                                                <td>{c.title}</td>
                                                <td>
                                                    <input type="number" min="0" max="31" step="0.5"
                                                        className="form-control height32"
                                                        placeholder={"Mặc định (" + mucMacDinh + ")"}
                                                        value={raw === undefined ? "" : raw}
                                                        onChange={(e) => setGiaTri((p) => ({ ...p, [c.id]: e.target.value }))} />
                                                </td>
                                                <td>
                                                    {kt.ok ? (
                                                        <span className={dungMacDinh ? "text-muted" : "text-primary font-weight-bold"}>
                                                            Trừ {muc} công/kỳ{dungMacDinh ? " (mặc định)" : ""}
                                                        </span>
                                                    ) : (
                                                        <span className="text-danger">Phải là số từ 0 đến 31</span>
                                                    )}
                                                </td>
                                                <td>
                                                    {c.so_ngoaile > 0
                                                        ? <span className="badge badge-warning">{c.so_ngoaile} người</span>
                                                        : <span className="text-muted">—</span>}
                                                </td>
                                                <td style={{ fontSize: 13 }}>
                                                    {c.thoi_diem_sua_text ? (
                                                        <>
                                                            <div><strong>{c.nguoi_sua || "—"}</strong>{c.ma_nguoi_sua ? " (" + c.ma_nguoi_sua + ")" : ""}</div>
                                                            <div className="text-muted">
                                                                {c.thoi_diem_sua_text}
                                                                {c.thay_doi_cuoi ? " · " + c.thay_doi_cuoi : ""}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <span className="text-muted">Chưa từng chỉnh sửa</span>
                                                    )}
                                                </td>
                                                <td className="text-nowrap">
                                                    <button type="button" className="btn btn-sm btn-primary"
                                                        disabled={dangLuu === c.id} onClick={() => luuCongTy(c)}>
                                                        {dangLuu === c.id ? <Spinner /> : "Lưu"}
                                                    </button>
                                                    {c.thoi_diem_sua_text && (
                                                        <button type="button" className="btn btn-sm btn-outline-secondary ml-1"
                                                            onClick={() => xemLichSu("company_id=" + c.id, c.title)}>
                                                            Lịch sử
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title"><h3>Ngoại lệ theo cá nhân</h3></div>
                    </div>

                    <div className="alert alert-warning" style={{ fontSize: 13 }}>
                        Người có ngoại lệ sẽ dùng mức ở đây, <strong>bỏ qua</strong> mức của công ty.
                        Dùng cho các trường hợp cá biệt mà cài theo công ty không phản ánh đúng.
                    </div>

                    <div className="row align-items-end mb-4" style={{ borderBottom: "1px solid #eee", paddingBottom: 15 }}>
                        <div className="col-lg-4 col-md-6 col-12 form-group mb-0">
                            <label>Nhân sự</label>
                            <SearchBoxModal apiname={"users"} placeholder="Chọn nhân sự"
                                colvalue={"id"} colname={"fullname"} name="user_id"
                                resetKey={resetKey} onChange={(e) => setUserMoi(e)} />
                        </div>
                        <div className="col-lg-2 col-md-3 col-12 form-group mb-0">
                            <label>Số công trừ</label>
                            <input type="number" min="0" max="31" step="0.5" className="form-control height32"
                                value={mucMoi} onChange={(e) => setMucMoi(e.target.value)} />
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 form-group mb-0">
                            <label>Ghi chú</label>
                            <input type="text" className="form-control height32" placeholder="Lý do áp dụng ngoại lệ"
                                value={ghiChuMoi} onChange={(e) => setGhiChuMoi(e.target.value)} />
                        </div>
                        <div className="col-lg-2 col-12 form-group mb-0">
                            <button type="button" className="btn btn-sm btn-success" disabled={dangLuu === "them"} onClick={themNgoaiLe}>
                                {dangLuu === "them" ? <Spinner /> : "Thêm ngoại lệ"}
                            </button>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table display data-table text-nowrap">
                            <thead>
                                <tr>
                                    <th>MSNV</th>
                                    <th>Họ và tên</th>
                                    <th>Phòng/ban</th>
                                    <th>Công ty</th>
                                    <th style={{ width: 120 }}>Trừ riêng</th>
                                    <th style={{ width: 120 }}>Mức công ty</th>
                                    <th>Ghi chú</th>
                                    <th style={{ width: 200 }}>Cập nhật</th>
                                    <th style={{ width: 150 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {ngoaiLe.length === 0 ? (
                                    <tr><td colSpan="9" className="text-center text-muted">Chưa có ngoại lệ nào</td></tr>
                                ) : ngoaiLe.map((r) => (
                                    <tr key={r.id}>
                                        <td>{r.code}</td>
                                        <td>{r.fullname}</td>
                                        <td>{r.part}</td>
                                        <td>{r.company}</td>
                                        <td><strong className="text-primary">{r.socongtru}</strong></td>
                                        <td className="text-muted">{r.muc_congty}</td>
                                        <td style={{ whiteSpace: "normal" }}>{r.ghichu}</td>
                                        <td style={{ fontSize: 13 }}>
                                            <div>{r.nguoi_sua || "—"}</div>
                                            <div className="text-muted">{r.thoi_diem_sua_text}</div>
                                        </td>
                                        <td className="text-nowrap">
                                            <button type="button" className="btn btn-sm btn-outline-danger"
                                                disabled={dangLuu === "xoa" + r.id} onClick={() => xoaNgoaiLe(r)}>
                                                {dangLuu === "xoa" + r.id ? <Spinner /> : "Bỏ"}
                                            </button>
                                            <button type="button" className="btn btn-sm btn-outline-secondary ml-1"
                                                onClick={() => xemLichSu("user_id=" + r.user_id, r.fullname)}>
                                                Lịch sử
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </AkkhorLayout>
    );
}
